// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_dialogTitle__FnJxD {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  height: 73px;
  border-bottom: 1px solid #dce1e6;
}
.style_dialogTitle__FnJxD .style_userLeftBlock__epbXa {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
}
.style_dialogTitle__FnJxD .style_userLeftBlock__epbXa .style_backToDialog__JxZ5o {
  display: none;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991.98px) {
  .style_dialogTitle__FnJxD .style_userLeftBlock__epbXa .style_backToDialog__JxZ5o {
    display: flex;
  }
}
.style_dialogTitle__FnJxD .style_userLeftBlock__epbXa .style_backToDialog__JxZ5o button {
  padding: 0 8px;
  font-size: 20px;
  border: none;
  background-color: transparent;
}
.style_dialogTitle__FnJxD .style_userLeftBlock__epbXa .style_userAvatar__V8EWQ {
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_dialogTitle__FnJxD .style_userLeftBlock__epbXa .style_userName__GZMLP {
  font-size: 14px;
  line-height: 15px;
  font-weight: 700;
  color: #000;
}
.style_dialogTitle__FnJxD .style_userRightBlock__3isCa {
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_dialogTitle__FnJxD .style_userRightBlock__3isCa button {
  padding: 8px;
  border: none;
  background-color: transparent;
}

@media (max-width: 556px) {
  .style_none__1dQmy {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/TitleBlock/style.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AADN;AAGM;EALF;IAMI,aAAA;EAAN;AACF;AAEM;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AAAR;AAII;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAKI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAOI;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AALN;;AAWE;EADF;IAEI,wBAAA;EAPF;AACF","sourcesContent":["@import '../../../variables.scss';\n\n.dialogTitle {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 16px;\n  height: 73px;\n  border-bottom: 1px solid #dce1e6;\n\n  .userLeftBlock {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n\n    .backToDialog {\n      display: none;\n      align-items: center;\n      justify-content: center;\n\n      @media (max-width: 991.98px) {\n        display: flex;\n      }\n\n      button {\n        padding: 0 8px;\n        font-size: 20px;\n        border: none;\n        background-color: transparent;\n      }\n    }\n\n    .userAvatar {\n      height: 48px;\n      width: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .userName {\n      font-size: 14px;\n      line-height: 15px;\n      font-weight: 700;\n      color: #000;\n    }\n  }\n\n  .userRightBlock {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    button {\n      padding: 8px;\n      border: none;\n      background-color: transparent;\n    }\n  }\n}\n\n.none {\n  @media (max-width: 556px) {\n    display: none !important;\n  }\n}\n\n// .dialog-title {\n//   caret-color: transparent;\n\n//   @media (max-width: 991.98px) {\n//     width: 100%;\n//   }\n// }\n\n// .user-message-hedeout {\n//   width: 100%;\n// }\n\n// .dtc {\n//   @media (max-width: 991.98px) {\n//     align-content: center;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogTitle": `style_dialogTitle__FnJxD`,
	"userLeftBlock": `style_userLeftBlock__epbXa`,
	"backToDialog": `style_backToDialog__JxZ5o`,
	"userAvatar": `style_userAvatar__V8EWQ`,
	"userName": `style_userName__GZMLP`,
	"userRightBlock": `style_userRightBlock__3isCa`,
	"none": `style_none__1dQmy`
};
export default ___CSS_LOADER_EXPORT___;
